var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09912 2H10.0991V16H4.09912V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09912 3V15H5.09912V3H9.09912ZM4.09912 2V16H10.0991V2H4.09912Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0991 0L10.0991 2V16L12.0991 13V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09912 0L4.09912 2H10.0991L12.0991 0H6.09912Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09912 2H10.0991L12.0991 0H6.09912L4.09912 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.ee2e97bdb2277c21a963df65adb53238.svg";
export { ForwardRef as ReactComponent };